export const v = {
	headerHeight: "5rem",
	smallDist: "1rem",
	mediumDist: "2rem",
	largeDist: "3rem",
	xLargeDist: "4rem",
	xxLargeDist: "5rem",
};

export const b = {
	medium: `(min-width: 600px)`,
	large: `(min-width: 1200px)`,
};

export const t = {
	fastSp: `all 0.3s ease`,
	midSp: `all 0.5s ease`,
	lowSp: `all 1s ease`,
};

export const color = {
	black: "#040404",
	pink: "#F5BFA8",
	red: "#851f08",
	grey: "#edf0f5",
	green: "#1f2f2f",
	lightGreen: "#4b9292",
	mainBg:
		"linear-gradient(90deg, rgba(133,31,8,0.6) 0%, rgba(245,191,168,1) 70%)",
};
